import {lazy,Suspense,useEffect,useState} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {ExternalLink,ListTree} from 'lucide-react';
import {useGlobalVault} from './store';
import {createVaultPopupBridge,vaultSessionChannel,vaultWindowUrl} from './window-bridge';
import {vaultQuerySync} from './query-sync';
const DeskWindow=lazy(()=>import('@/features/drawing-desk/components/DrawingDeskWindow').then(m=>({default:m.DrawingDeskWindow})));
/** The library owns a native browser window. Only chart popups stay in this document. */
export function GlobalVault(){
 const {open,setOpen,deskStock,closeDesk}=useGlobalVault(),client=useQueryClient();
 const [blocked,setBlocked]=useState(false),[fallback,setFallback]=useState('');
 useEffect(()=>{
  const channel=vaultSessionChannel(window),base=import.meta.env.BASE_URL||'/';
  setFallback(vaultWindowUrl(window.location.origin,base,channel));
  const bridge=createVaultPopupBridge(window,base,channel,{
   // The request counter wakes the native window; focusing it must not reset map zoom.
   context:()=>{const state=useGlobalVault.getState();return {symbol:state.clients[state.activeClient??'']?.symbol??state.selectedSymbol,openToken:0,dark:document.documentElement.classList.contains('dark'),connected:true};},
   blocked:()=>{setBlocked(true);useGlobalVault.getState().setOpen(false);},
   closed:()=>{useGlobalVault.getState().setOpen(false);},
   message:message=>{
    if(message.type==='pick')useGlobalVault.getState().pick(message.symbol);
    else if(message.type==='open-desk')useGlobalVault.getState().openDesk({symbol:message.symbol,name:message.name});
    else if(message.type==='changed')queries.receive();
   },
  });
  const queries=vaultQuerySync(client,()=>bridge.changed());
  const unsubscribe=useGlobalVault.subscribe((state,previous)=>{
   if(state.open&&state.openToken!==previous.openToken){setBlocked(false);bridge.open();}
   else if(!state.open&&previous.open)bridge.close();
   else bridge.sync();
  });
  const theme=new MutationObserver(()=>bridge.sync());theme.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  return()=>{unsubscribe();queries.dispose();theme.disconnect();bridge.dispose();};
 },[client]);
 return <>
  <button type="button" data-global-vault-toggle aria-label={open?'切换到独立标的库窗口':'打开独立标的库窗口'} aria-expanded={open}
   title="标的库使用独立窗口，可与画线工作台并排；再次点击切换到已打开的窗口"
   onClick={()=>setOpen(true)} className="fixed right-2 top-1/2 z-[60] flex -translate-y-1/2 items-center gap-1 rounded-lg border border-primary/30 bg-card px-2 py-2.5 text-xs font-medium text-primary shadow-md sm:right-4">
   <ListTree className="h-4 w-4"/><span className="[writing-mode:vertical-rl] sm:[writing-mode:horizontal-tb]">标的库</span><ExternalLink className="h-3 w-3"/>
  </button>
  {blocked&&<div role="alert" className="fixed bottom-4 right-4 z-[60] max-w-sm rounded-lg border border-amber-500/40 bg-card p-3 text-xs shadow-md"><p>浏览器拦截了标的库独立窗口。请允许本站弹窗后，点击标的库按钮重试。</p><p className="mt-2">也可<a href={fallback} target="_blank" rel="noopener noreferrer" className="mx-1 text-primary underline">在新标签页独立编辑</a>，此方式不联动原页面。</p><button type="button" className="mt-2 text-muted-foreground" onClick={()=>setBlocked(false)}>关闭提示</button></div>}
  {deskStock&&<Suspense fallback={<div role="status" className="fixed bottom-4 right-4 z-[60] rounded border bg-card p-3 text-sm">正在打开画线工作台…</div>}><DeskWindow vaultPopup stock={deskStock} onClose={closeDesk} storageKey="global.vault.desk-window.v1"/></Suspense>}
 </>;
}
